import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter } from "react-router-dom";

// Initialize i18n (side effect import)
import "./18n";

const rootElement = document.getElementById("root");

const AppWrapper = (
  <Provider store={store}>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </Provider>
);

// Use hydrate if the root element already has children (for react-snap prerendering)
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(AppWrapper, rootElement);
} else {
  ReactDOM.render(AppWrapper, rootElement);
}

// Report web vitals in production for monitoring
if (process.env.NODE_ENV === "production") {
  import("./reportWebVitals").then(({ default: reportWebVitals }) => {
    reportWebVitals();
  });
}


// SCRIPT: 1 for USA client js execution
function reloadOnChunkError(message) {
  const hasReloaded = sessionStorage.getItem("chunk-error-reloaded");

  if (
    !hasReloaded &&
    (
      message.includes("Loading chunk") ||
      message.includes("ChunkLoadError") ||
      message.includes("failed to fetch dynamically imported module")
    )
  ) {
    sessionStorage.setItem("chunk-error-reloaded", "true");
    window.location.reload();
  }
}

window.addEventListener("error", function (event) {
  reloadOnChunkError(event.message || "");
});

window.addEventListener("unhandledrejection", function (event) {
  reloadOnChunkError(event.reason?.message || "");
});

window.addEventListener("load", function () {
  sessionStorage.removeItem("chunk-error-reloaded");
});

